import Constant from "./Constant"
import NetworkLogic from "./NetworkLogic";
import Utils from "./Utils";
import {Global} from "./Global";
import UIManager from "./UIManager";

class AudioManager {
    soundPath: string = 'Sounds/'
    currentBgMusic: number = -1
    isMusicEnabled: boolean = true
    isMusicPaused: boolean = false
    isSoundEnabled: boolean = true
    musicVolume: number = 1 //音乐音量
    soundVolume: number = 1 //音效音量
    commonSoundPath = null
    commonSound = null

    musicList = null;

    constructor () {
        this.commonSoundPath = {
            clickButtonSound: 'Sounds/button',
        }

        this.commonSound = {
            clickButton: null,
        }

        if (cc.sys.localStorage.getItem('Music') === null) {
            cc.sys.localStorage.setItem('Music', 1)
            cc.sys.localStorage.setItem('Sound', 1)
            cc.sys.localStorage.setItem('MusicVolume', Constant.DefaultMusicVolume)
            cc.sys.localStorage.setItem('SoundVolume', Constant.DefaultSoundVolume)
        }

        this.isMusicEnabled = (cc.sys.localStorage.getItem('Music') === '1')
        this.isSoundEnabled = (cc.sys.localStorage.getItem('Sound') === '1')
        this.musicVolume = parseFloat(cc.sys.localStorage.getItem('MusicVolume') || '1')
        this.soundVolume = parseFloat(cc.sys.localStorage.getItem('SoundVolume') || '1')
    }

    async startPlayHallMusic() {
        let isMusicPaused = cc.sys.localStorage.getItem(Global.localStorageId.pauseMusic);
        if  (isMusicPaused === "true"){
            return;
        }
        let musicName = cc.sys.localStorage.getItem(Global.localStorageId.MusicName)
        await this.getMuiscList();
        if  (Array.isArray(this.musicList) && this.musicList.length > 0){
            let musicCfg = null
            for (let i = 0;i < this.musicList.length;i++){
                let data = this.musicList[i];
                let fileName = data.url.substring(data.url.lastIndexOf("/") + 1)
                if  (fileName === musicName){
                    musicCfg = data;
                    break;
                }
            }

            if  (!musicCfg){
                musicCfg = this.musicList[0]
            }

            let musicFileName = musicCfg.url.substring(musicCfg.url.lastIndexOf("/") + 1, musicCfg.url.lastIndexOf("."))
            let extName = musicCfg.url.substring(musicCfg.url.lastIndexOf("."))
            let folderPath = jsb.fileUtils.getWritablePath() + "SoundCache/"
            let filePath = folderPath + musicFileName + extName

            if (jsb.fileUtils.isFileExist(filePath)) {
                this.loadMusic(filePath,musicFileName + extName);
        }else {
                !jsb.fileUtils.isDirectoryExist(folderPath) && jsb.fileUtils.createDirectory(folderPath)
                Utils.saveUrlFile(musicCfg.url, filePath, function (fullPath) {
                    this.loadMusic(fullPath,musicFileName + extName);
                }.bind(this))
            }
        }

    }

    loadMusic(filePath,name){
        cc.loader.load(filePath, function (err, clip) {
            if (!err) {
                    this.stopBgMusic()
                    this.currentBgMusic = cc.audioEngine.play(clip, true, this.isMusicEnabled ? this.musicVolume : 0)
                    this.isMusicPaused = false
                cc.sys.localStorage.setItem(Global.localStorageId.pauseMusic, "false");
                cc.sys.localStorage.setItem(Global.localStorageId.MusicName, name)
                cc.log("====保存的名字：",name);
                }
            }.bind(this))
        }

    // startPlayBgMusic (url: string | cc.AudioClip, cb: Function = null) {
    //     if (url instanceof cc.AudioClip) {
    //         this.stopBgMusic()
    //         this.currentBgMusic = cc.audioEngine.play(url, true, this.isMusicEnabled ? this.musicVolume : 0)
    //         this.isMusicPaused = false
    //         cc.sys.localStorage.setItem(Global.localStorageId.pauseMusic,"false");
    //         if(!!cb) cb()
    //     }else {
    //         url = this.soundPath + url
    //         cc.loader.loadRes(url, function (err, clip) {
    //             if (!!err){
    //                 cc.log('startPlayBgMusic failed')
    //             }else{
    //                 this.stopBgMusic()
    //                 this.currentBgMusic = cc.audioEngine.play(clip, true, this.isMusicEnabled ? this.musicVolume : 0)
    //                 this.isMusicPaused = false
    //                 cc.sys.localStorage.setItem(Global.localStorageId.pauseMusic,"false");
    //             }
    //             if(!!cb) cb(err)
    //         }.bind(this))
    //     }
    // }

    pauseMusic () {
        cc.audioEngine.pause(this.currentBgMusic)
        this.isMusicPaused = true
    }

    async resumMusic() {
        if (this.currentBgMusic === null || this.currentBgMusic < 0) {
            await this.startPlayHallMusic();
        }else {
        cc.audioEngine.resume(this.currentBgMusic)
        this.isMusicPaused = false
            cc.sys.localStorage.setItem(Global.localStorageId.pauseMusic, "false")
        }

    }

    stopBgMusic () {
        if (this.currentBgMusic === null || this.currentBgMusic < 0) return
        cc.audioEngine.stop(this.currentBgMusic)
        this.currentBgMusic = -1
    }

    playSound (url: string | cc.AudioClip, loop: boolean = false, cb: Function = null) {
        if (!url || !this.isSoundEnabled) return
        if (loop !== true) loop = false
        
        let soundID = -1

        if (url instanceof cc.AudioClip) {
            soundID = cc.audioEngine.play(url, loop, this.soundVolume)
            cb && cb(soundID)
        }else {
            url = this.soundPath + url
            cc.loader.loadRes(url, function (err, clip) {
                if (!!err){
                    console.error('playSound failed:' + url)
                }else{
                    soundID = cc.audioEngine.play(clip, loop, this.soundVolume)
                    cb && cb(soundID)
                }
            }.bind(this))
        }
    }

    playCommonSoundClickButton () {
        if (!this.isSoundEnabled) return
        if (this.commonSound.clickButton !== null){
            cc.audioEngine.play(this.commonSound.clickButton, false, this.soundVolume)
        }else {
            cc.loader.loadRes(this.commonSoundPath.clickButtonSound, function (err, clip) {
                if (!!err){
                    cc.log('playCommonSoundClickButton failed')
                }else{
                    this.commonSound.clickButton = clip
                    cc.audioEngine.play(this.commonSound.clickButton, false, this.soundVolume)
                }
            }.bind(this))
        }
    }

    //Music 1为开，0为关
    setMusicOn () {
        cc.sys.localStorage.setItem(Global.localStorageId.Music, 1)
        cc.audioEngine.setVolume(this.currentBgMusic, this.musicVolume)
        this.isMusicEnabled = true
    }

    setMusicOff () {
        cc.sys.localStorage.setItem(Global.localStorageId.Music, 0)
        cc.audioEngine.setVolume(this.currentBgMusic, 0)
        this.isMusicEnabled = false
    }

    getMusicEnabled () {
        return this.isMusicEnabled
    }

    //Sound 1为开，0为关
    setSoundOn () {
        cc.sys.localStorage.setItem('Sound', 1)
        this.isSoundEnabled = true
    }
    
    setSoundOff () {
        cc.sys.localStorage.setItem('Sound', 0)
        this.isSoundEnabled = false
    }

    getSoundEnabled () {
        return this.isSoundEnabled
    }

    setMusicVolume (volume) {
        this.musicVolume = parseFloat(volume.toFixed(1))
        if (this.musicVolume === parseFloat(cc.sys.localStorage.getItem('MusicVolume'))) {
        } else {
            cc.sys.localStorage.setItem('MusicVolume', this.musicVolume)
        }

        if (this.currentBgMusic >= 0){
            cc.audioEngine.setVolume(this.currentBgMusic, this.musicVolume)
        }
    }

    getMusicVolume () {
        return this.musicVolume
    }

    setSoundVolume (volume) {
        this.soundVolume = parseFloat(volume.toFixed(1))
        if (this.soundVolume === parseFloat(cc.sys.localStorage.getItem('SoundVolume'))) {
        } else {
            cc.sys.localStorage.setItem('SoundVolume', this.soundVolume)
        }
    }

    getSoundVolume () {
        return this.soundVolume
    }

    async getMuiscList() {
        if (!this.musicList) {
            this.musicList = await this._getMusicList()
        }
        return this.musicList;
    }

    _getMusicList():Promise<any>{
        return new Promise<any>(resolve => {
            NetworkLogic.getMusicConfig(function (data) {
                resolve(data)
            }.bind(this),function (){
                resolve(null)
            })
        })
    }
}

export default new AudioManager()